import { calcTotalPrice } from './calcTotalPrice.js';

class ProductWarranty extends HTMLElement {
  connectedCallback() {
    const warrantyInputs = this.querySelectorAll('.warranty_variants input');
    warrantyInputs.forEach(el => el.addEventListener('click', this.#handleWarrantyUpdate));

  }

  disconnectedCallback() {

    
    // const warranty_cta = this.querySelector('.warranty_cta');
    // warranty_cta?.removeEventListener('click', this.#handleWarrantyUpdate);
  }

  /**
   * warranty logic
   *
   * @param {MouseEvent} event - Thevent mouse event.
   */
  #handleWarrantyUpdate(event) {
    const target = /** @type {HTMLElement} */ (event.target);

    // update the productForm id that will be added to the cart
    const  productWarrantyId =  this.closest('.product-details')?.querySelector('[name="productWarrantyId"]')
    const selectedID = target.dataset.variantId;
    if (productWarrantyId && productWarrantyId instanceof HTMLInputElement) { productWarrantyId.value = selectedID ?? ''; }

    // select the correct image related to the selected index
    const productWarrantyImages = target.closest('.product-warranty__container')?.querySelectorAll('.warranty_image');
    if (productWarrantyImages) {
      productWarrantyImages.forEach(img => img.classList.add('hidden'));
      const index = Number(target.parentElement?.dataset.index);
      if (productWarrantyImages[index]) { productWarrantyImages[index].classList.remove('hidden');}
    }

    calcTotalPrice();

  }
}

if (!customElements.get('product-warranty')) {
  customElements.define('product-warranty', ProductWarranty);
}
